/* Day/night, ported from dash/app.js:2394.
 *
 * Auto flips to night 19:00–07:00 local. That is deliberately blunt: a real
 * sunset calculation drifts with latitude and season and would flip the screen
 * mid-passage, whereas a fixed pair of hours is predictable and the crew learns
 * it. A manual choice sticks until it is cleared. */

export type ThemeMode = 'auto' | 'day' | 'night';

const NIGHT_FROM = 19;
const NIGHT_TO = 7;

export function isNightAt(d: Date): boolean {
  const h = d.getHours();
  return h >= NIGHT_FROM || h < NIGHT_TO;
}

class Theme {
  mode = $state<ThemeMode>('auto');
  #now = $state(Date.now());

  /* Re-evaluate on the minute rather than the second. The only thing that
   * changes is a boolean that flips twice a day. */
  constructor() {
    setInterval(() => (this.#now = Date.now()), 60_000);
  }

  readonly night = $derived(
    this.mode === 'auto' ? isNightAt(new Date(this.#now)) : this.mode === 'night'
  );

  /** Cycle the button: auto → day → night → auto. */
  cycle() {
    this.mode = this.mode === 'auto' ? 'day' : this.mode === 'day' ? 'night' : 'auto';
  }

  get label(): string {
    return this.mode === 'auto' ? '☼ AUTO' : this.mode === 'day' ? '☼ DAY' : '☾ NIGHT';
  }
}

export const theme = new Theme();
